<template>
  <div
    class="img-preview-content"
    :style="{
      'background-image': 'url(' + resolveImg + ')',
      ...resolveWidth,
    }"
  >
    <a><icon-zoom-img class="w-100" @click.native="showFullscreen" /></a>
    <image-preview-fullscreen
      :imageUrl="imageUrl"
      :bindValue="showFullscreenImage.show"
      @closeModal="hideFullscreen"
    />
  </div>
</template>

<script>
import IconZoomImg from "@/@core/components/svg/common/IconZoomImg.vue";
import { computed, reactive } from "@vue/composition-api";
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";

import useModal from "@/@core/components/base-modal/hooks/useModal";
import ImagePreviewFullscreen from "@/views/components/image-preview-list/ImagePreviewFullscreen.vue";
export default {
  components: { IconZoomImg, ImagePreviewFullscreen },
  props: {
    imageUrl: { type: String, default: "" },
    width : {type : String , default : "250px"},
    height : {type : String , default : "135px"}
  },
  setup(props) {
    const { openModal, closeModal } = useModal();
    const showFullscreenImage = reactive({
      show: false,
    });

    const showFullscreen = () => {
      showFullscreenImage.show = true;
      openModal();
    };

    const hideFullscreen = () => {
      showFullscreenImage.show = false;
      closeModal();
    };
    const resolveWidth = computed(() => {
      return {
        width: props.width,
        height: props.height,
      };
    });

    const resolveImg = computed(() => {
      return props.imageUrl ? props.imageUrl : DefaultImg;
    });
    return {
      resolveWidth,
      resolveImg,

      showFullscreen,
      hideFullscreen,
      showFullscreenImage,
    };
  },
};
</script>

<style scoped>
.img-preview-content {
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  width: 250px;
  height: 135px;
  border-radius: 10px;
  border: 1px dashed #d1d1d1;
}

.img-preview-content > a {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  cursor: pointer;
}
</style>
